import styled from 'styled-components'

export const Panel = styled.div`
  display: block;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  border-radius: 5px;
  background: #f7f7f7;
  padding: 24px;
  height: fit-content;
`;